import { ReviewsStar } from '@/components/Icons';
import { Box } from '@mui/material';

function Star({ fill = 0, size = 12 }) {
	return (
		<ReviewsStar
			sx={{
				width: size,
				height: size,
				color: fill ? 'primary.main' : '#B8B8B8'
			}}
		/>
	);
}

function Rating({ value = 5, max = 5, sx = {}, starSize }) {
	return (
		<Box display="flex" gap="4px" sx={sx}>
			{Array.from({ length: max }).map((_, i) => {
				const diff = value - i;

				let fill = false;

				if (diff >= 1) {
					fill = true;
				}

				return <Star key={i} fill={fill} size={starSize} />;
			})}
		</Box>
	);
}

export default Rating;
